import { useEffect, useState, useRef, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { useDispatch } from "react-redux";
import { getLabConfig, getSystemMsg, getCategories } from '../../utils/api';
import NORDX_Header2 from './NORDX_Header2'	;

import { searchTestsThunk, setIsLoading } from '../../store/tests';

import LabIDContext from '../../store/LabIDContext';
import HeaderClasses from './TestsHeader.module.css';

const components = {
  'NORDX_Header2': NORDX_Header2,
};
function DynamicComponent({ componentName }) {
  const Component = components[componentName] || (() => <p></p>);
  return <Component />;
}

function FileDisplay({ filePath, fallbackComponent }) {
  const [fileExists, setFileExists] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkFile = async () => {
      try {
        const response = await fetch(filePath, { method: 'HEAD' });
        setFileExists(response.ok);
      } catch (error) {
        setFileExists(false);
      } finally {
        setLoading(false);
      }
    };

    checkFile();
  }, [filePath]);

  if (loading) {
    return <p>Loading...</p>;
  }
	const lab_header = filePath.split(".");

  return fileExists ? (
    <div>
      {/* Display content if the file exists */}
	  < DynamicComponent componentName={lab_header[0]} />
      {/* You can add more content here, like displaying the file itself */}
    </div>
  ) : (
    fallbackComponent || <p>File not found.</p>
  );
}
const TestsHeader = (props) => {
    const [searchTerm, setSearchTerm] = useState('');
	const [hasCategories, setHasCategories] = useState(false);
    const isInitial = useRef(true);
    const dispatch = useDispatch();
    const banner=props.banner;
	const labid = useContext(LabIDContext);
    useEffect(() => {
        if(!isInitial.current){
            const searchTimeout = setTimeout(() => {
                dispatch(setIsLoading());
                dispatch(searchTestsThunk(searchTerm))
            }, 750);

            return () => {
                clearTimeout(searchTimeout);
            };
        }

        isInitial.current = false;

        
    }, [searchTerm, dispatch, isInitial]);
	
    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };
		//Fetch all categories to determine if categories should be displayed at all
    useEffect(() => {
        async function fetchCategories() {
            const fetchedCategories = await getCategories('0');
            if(fetchedCategories.length>0) {
				setHasCategories(true);
			}
        }

        fetchCategories();
    }, []);
    return (
	<>
        <header className={HeaderClasses.testsHeader}>
            <div>
				{hasCategories &&
					<button aria-label="Categories" className={HeaderClasses.menuButton} onClick={props.onOpenMenu}>
						<FontAwesomeIcon icon={faBars} className={HeaderClasses.headerIcon}/>
					</button>
				}
            </div>
            <div className={HeaderClasses.promotionContainer}>
            	<div className={HeaderClasses.promotionItem}>
					{banner && Object.keys(banner).length > 0 && <div>{banner}</div>}
            	</div>               	
    		</div>
            <div className={HeaderClasses.actionArea}>
            	<label htmlFor='testSearch' className={HeaderClasses.searchLabel}>
					<span className="sr-only">Search tests by name</span>
                    <i className={HeaderClasses.searchIcon}><FontAwesomeIcon icon={faMagnifyingGlass}/></i>
                    <input type='search' id='testSearch' name='testSearch' className={HeaderClasses.headerSearch} value={searchTerm} onChange={handleSearch}/>
                </label>
            </div>
        </header>
		<FileDisplay filePath={`${labid}_Header2.js`} />
		</>
    );
};

export default TestsHeader;

